<template>
    <div>
        <Toolbar>
            <template v-slot:right>
                <a :href="$route('stores.create')"
                      class="btn btn-bg-white btn-hover-primary btn-text-dark-50 btn-icon-primary font-weight-bolder font-size-sm px-5">
                    <span class="svg-icon svg-icon-md">
                        <i class="fas fa-plus"/>
                    </span>
                    {{ __('store.create_new_store') }}
                </a>
                <HelpButton />
            </template>
        </Toolbar>

        <Card>
            <!-- HEADER -->
            <template v-slot:icon>
                <i class="fas fa-store font-size-h2"/>
            </template>
            <template v-slot:title>
                {{ __('navigation.your_stores') }}
            </template>
            <template v-slot:description>
                Manage your store locations
            </template>

            <!-- TOOLBAR -->
            <template v-slot:toolbar>
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text border-0">
                            <i class="fas fa-search"/>
                        </span>
                    </div>
                    <input class="form-control form-control-solid pl-0"
                           type="text"
                           style="min-width: 240px;"
                           :placeholder="__('actions.search_thing', {thing: __('general.stores')})"
                           v-model="searchString"
                    >
                </div>
            </template>

            <!-- STORES -->
            <div class="table-responsive">
                <table class="table table-hover table-vertical-center table-cell-fullwidth">
                    <thead>
                    <tr>
                        <th>{{ __('store.name') }}</th>
                        <th>{{ __('general.country') }}</th>
                        <th class="text-right">{{ __('general.actions') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="store in filteredStores" :key="store.id">
                        <td>
                            <Store :store="store" />
                        </td>
                        <td>
<!--                            <CountryFlag v-if="store.attributes.address.country"-->
<!--                                         class="mt-n1"-->
<!--                                         :country='store.attributes.address.country'-->
<!--                                         size='normal'-->
<!--                                         :rounded="true"-->
<!--                            />-->
                            <Badge v-if="store.attributes.address.country" type="badge-secondary">
                                {{ store.attributes.address.country.toUpperCase() }}
                            </Badge>
                        </td>
                        <td>
                            <div class="d-flex flex-row justify-content-end gap-1">
                                <div class="btn-group">
                                    <Link as="button"
                                          :href="$route('store.edit', [store.id])"
                                          class="btn btn-default btn-hover-primary btn-sm">
                                        <i class="fas fa-edit"/>
                                        {{ __('actions.edit_thing', {thing: __('general.store')}) }}
                                    </Link>
                                    <a target="_blank" :href="storeLink(store)"
                                       class="btn btn-default btn-hover-info btn-sm">
                                        <i class="fas fa-eye"/>
                                        {{ __('actions.view') }}
                                    </a>
                                </div>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </Card>
    </div>
</template>

<script>
import Toolbar from "@components/Toolbar.vue";
import BackButton from "@components/BackButton.vue";
import Card from "@components/Cards/Card.vue";
import StoreAddress from "@components/Store/StoreAddress.vue";
import CountryFlag from "vue-country-flag";
import { Link } from '@inertiajs/vue2';
import Store from "@components/Store/Store.vue";
import Badge from "@components/Badge.vue";
import HelpButton from '@components/HelpButton.vue'

export default {
    components: {
        HelpButton,
        Badge,
        Store,
        StoreAddress,
        Card,
        BackButton,
        Toolbar,
        Link,
        CountryFlag
    },

    props: {
        stores: Array,
    },

    data() {
        return {
            searchString: ''
        }
    },

    methods: {
        storeLink(store) {
            return this.$page.props.frontend_url + store.attributes.link
        },
    },

    computed: {
        filteredStores() {
            if (this.searchString.trim().length === 0) {
                return this.stores;
            }

            let stores = [];
            for (let store of this.stores) {
                for (let searchPart of this.searchString.trim().toLowerCase().split(" ")) {
                    if (store.attributes.name.toLowerCase().includes(searchPart)) {
                        stores.push(store);
                    } else if (store.attributes.address.city.toLowerCase().includes(searchPart)) {
                        stores.push(store);
                    } else if (store.attributes.address.street1.toLowerCase().includes(searchPart)) {
                        stores.push(store);
                    } else if (store.attributes.address.postcode.toLowerCase().includes(searchPart)) {
                        stores.push(store);
                    }
                }
            }

            return stores;
        }
    }
}
</script>
